// Latinco: bloquea envíos de bots (campo trampa lleno, envío instantáneo o repetido)
(() => {
  if (window.ltnAntispam) return;
  window.ltnAntispam = true;
  const loaded = Date.now();
  document.addEventListener('submit', (e) => {
    const form = e.target;
    const trap = form.querySelector('[data-ltn-hp]');
    if (!trap) return;
    const tooFast = Date.now() - loaded < 3000;
    const last = Number(sessionStorage.getItem('ltn-form-sent') || 0);
    const repeated = Date.now() - last < 8000;
    if (trap.value || tooFast || repeated) {
      e.preventDefault();
      return;
    }
    try { sessionStorage.setItem('ltn-form-sent', String(Date.now())); } catch (_) {}
  }, true);
})();
